import * as React from 'react';
import { INav, NavUrls } from '../layout/layoutConstants';
import { lazyComponents } from '../layout/lazyComponents';

export const enum LogisticsUrls {
  admin = '/admin',
  calendar = '/calendar',
  carrierDetail = '/carriers/:carrierId',
  carriers = '/carriers',
  dashboard = '',
  loadDetail = '/loads/:loadNumber',
  openSalesLineSummary = '/openSalesLines',
  orderLookup = '/orderLookup',
  orderLookupDetail = '/orderLookup/:orderId',
  shipmentDetail = '/shipments/:shipmentId',
  shipments = '/shipments/:shipmentId',
  syncEventLog = '/log',
  unallocatedDetails = '/logistics/unallocated/:id',
  users = '/users'
}

export const getFullLogisticsUrl = (url: LogisticsUrls): string => `${NavUrls.logistics}${url}`;

export const logisticsRoutes: INav[] = [
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsAdminPage />,
    name: 'Logistics Admin',
    path: LogisticsUrls.admin,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsCalendarPage />,
    filterComponent: <lazyComponents.LogisticsFilterButton type="calendar" />,
    name: 'Logistics Calendar',
    path: LogisticsUrls.calendar,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsCarrierPage />,
    name: 'Logistics Carriers',
    path: LogisticsUrls.carriers,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.CarrierDetailPage />,
    name: 'Logistics Carrier Detail Page',
    path: LogisticsUrls.carrierDetail,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsPage />,
    filterComponent: <lazyComponents.LogisticsFilterButton type="dashboard" />,
    name: 'Logistics Dashboard',
    path: '',
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LoadWrapperPage />,
    name: 'Logistics Detail Page: Load ',
    path: LogisticsUrls.loadDetail,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsDealerPageContainer />,
    name: 'Open Sales Line Summary',
    path: LogisticsUrls.openSalesLineSummary,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsOrderLookupSearch />,
    name: 'Order Lookup',
    path: LogisticsUrls.orderLookup,
    permissionTypes: ['logistics', 'sales']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsOrderLookup />,
    name: 'Order Lookup',
    path: LogisticsUrls.orderLookupDetail,
    permissionTypes: ['logistics', 'sales']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.ShipmentDetailPageWrapper />,
    name: 'Logistics Shipment: ',
    path: LogisticsUrls.shipmentDetail,
    permissionTypes: ['sales', 'logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsSyncLogEvent />,
    name: 'Logistics Sync Event Log',
    path: LogisticsUrls.syncEventLog,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsDealerPageContainer />,
    name: 'Logistics Dealer Summary Page',
    path: LogisticsUrls.unallocatedDetails,
    permissionTypes: ['logistics']
  },
  {
    caseSensitive: false,
    element: <lazyComponents.LogisticsUsers />,
    name: 'Logistics Users Page',
    path: LogisticsUrls.users,
    permissionTypes: ['logistics']
  }
];
